import React from "react";
import Pool from '../UserPool'
import { useHistory } from 'react-router-dom'
import { CognitoUser } from 'amazon-cognito-identity-js'

export default function ForgotPassword() {
  const history = useHistory()
  const [Email, setEmail] = React.useState(null)
  const [Confirmpassword, setConfirmpassword] = React.useState(null)
  const [Code, setCode] = React.useState(null)
  const [password, setPassword] = React.useState(null)
  const [alert, setAlert] = React.useState(false)
  const [alert2, setAlert2] = React.useState(false)
  const [alert3, setAlert3] = React.useState(false)
  const [alertp, setAlertp] = React.useState(false)
  const [alertC, setAlertC] = React.useState(false)
  const [msgp, setMsgp] = React.useState('Please enter password')
  const [msgC, setMsgC] = React.useState('Please enter Confirm password')
  const [msg1, setMsg1] = React.useState('Please enter Code')
  const [msg2, setMsg2] = React.useState('Incorrect UserName or is not registered.')
  const [loading, setLoading] = React.useState(false)
  const [stage, setStage] = React.useState(1);
  function GobackLogin() {

    history.push('/login')
  }


  async function handleresetPassword(e) {
    e.preventDefault();
    setAlert2(false)
    setAlert3(false)
    setAlertC(false)
    setAlertp(false)
    setAlert(false)
    if ((Code == "") || (Code == null)) {
      setAlert(true); return;
    }
    if ((password == "") || (password == null)) {
      setAlertp(true); return;
    }
    if ((Confirmpassword == "") || (Confirmpassword == null)) {
      setAlertC(true); return;
    }
    if (password !== Confirmpassword) {
      setAlert3(true);
      setMsg2("Passwords are not the same");
      return;
    }
    else {

      try {
        setLoading(true)
        getUser().confirmPassword(Code, password, {
          onSuccess: data => {
            console.log("onSuccess:", data);
            setLoading(false);
            history.push("/");
          },
          onFailure: err => {
            console.error("onFailure:", err);
            setLoading(false);
            setMsg2(err.message);
            setAlert3(true);
          }
        });
      }
      catch
      {
        setMsg2("Code is Invalid.");
        setLoading(false);
        setAlert3(true);

      }
    }
  }


  const getUser = () => {
    return new CognitoUser({
      Username: Email.toLowerCase(),
      Pool
    });
  };


  async function handlesendCode(e) {
    e.preventDefault();

    setAlert(false)
    setAlert3(false)
    if ((Email == "") || (Email == null)) {
      setMsg1('Please enter UserName')
      setAlert(true)
      return;
    }


    else {

      setLoading(true)

      getUser().forgotPassword({
        onSuccess: data => {
          setLoading(false)
          console.log("onSuccess:", data);
        },
        onFailure: err => {
          setLoading(false)
          setAlert3(true)
          console.error("onFailure:", err);
        },
        inputVerificationCode: data => {
          setLoading(false)
          console.log("Input code:", data);
          setStage(2);
          setMsg2("We have sent you a code on your email, please entered that code.");
          setAlert3(true)
        }
      });
    }
  }
  return (

    <section class="ftco-section">
      <div class="content">
        <div class="header-area">
          <a href="#"><img src="assets/img/logo.png" alt="logo-singin.png"></img></a>
        </div>
        <div class="row wrap d-md-flex">
          <div class="col-md-8 login-wrap">
            <div class="inner_content">
              <div class="d-flex">
                <div class="w-100">
                  <h3 class="mb-0">Forgot Password</h3>
                </div>
              </div>
              {stage === 1 && (
                <form onSubmit={handlesendCode} class="signin-form">
                  <h6>
                    {alert3 && (
                      <span style={{ color: 'red' }}>{msg2}</span>
                    )}</h6>
                  <div class="form-group mb-0">
                    <label class="label" for="name">
                      UserName{' '}
                      {alert && (
                        <span style={{ color: 'red' }}>{msg1}</span>
                      )}
                    </label>
                    <input type="text"
                      value={Email}
                      class="form-control"
                      onChange={(e) => setEmail(e.target.value)} required />
                  </div>


                  {/* <div class="forget_target text-md-right">
                  <a href="#">Forgot Password?</a>
                </div> */}
                  <div class="form-group mb-0">
                    <a onClick={handlesendCode}>
                      <button type="submit" class="btn btn-primary rounded submit submit_btn">
                        {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                        Forget Password</button></a>
                  </div>

                </form>
              )}
              {stage === 2 && (
                <form onSubmit={handleresetPassword} class="signin-form">
                  <h6>
                    {alert3 && (
                      <span style={{ color: 'red' }}>{msg2}</span>
                    )}</h6>
                  <div class="form-group mb-3">
                    <label class="label" for="name">
                      Code{' '}
                      {alert && (
                        <span style={{ color: 'red' }}>{msg1}</span>
                      )}
                    </label>
                    <input type="text"
                      value={Code}
                      class="form-control"
                      onChange={(e) => setCode(e.target.value)} required />
                  </div>
                  <div class="form-group mb-3">
                    <label class="label" for="name">
                      Password{' '}
                      {alertp && (
                        <span style={{ color: 'red' }}>{msgp}</span>
                      )}
                    </label>
                    <input type="password"
                      value={password}
                      class="form-control"
                      onChange={(e) => setPassword(e.target.value)} required />
                  </div>
                  <div class="form-group mb-3">
                    <label class="label" for="name">
                      Confirm Password{' '}
                      {alertC && (
                        <span style={{ color: 'red' }}>{msgC}</span>
                      )}
                    </label>
                    <input type="password"
                      value={Confirmpassword}
                      class="form-control"
                      onChange={(e) => setConfirmpassword(e.target.value)} required />
                  </div>

                  {/* <div class="forget_target text-md-right">
                    <a href="#">Forgot Password?</a>
                  </div> */}
                  <div class="form-group">
                    <a onClick={handleresetPassword}>
                      <button type="submit" class="btn btn-primary rounded submit submit_btn">
                        {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                        Change Password</button></a>
                  </div>

                </form>

              )}
              <p class="text-center register_content">Remember your password? <a onClick={GobackLogin} data-toggle="tab" href="#signup">Login</a></p>
            </div>
          </div>
          <div class="col-md-4 city-dashboard1 img Landbrige_map" >
            <div class="bg_content">
              <img src="assets/img/LB-Icon-White.svg" alt="LB-Icon-White.svg"></img>
              <h2>land analysis made simple</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}